import React from 'react';
import { TEMPLATE_KINDS, TEMPLATE_KIND_ORDER, TemplateKind } from './templateKinds';

interface TemplateKindTabsProps {
    value: TemplateKind | '';
    counts: Record<string, number>;
    onChange: (kind: TemplateKind | '') => void;
}

const TemplateKindTabs: React.FC<TemplateKindTabsProps> = ({ value, counts, onChange }) => {
    const tabs: { key: TemplateKind | ''; label: string }[] = [
        { key: '', label: 'Todos' },
        ...TEMPLATE_KIND_ORDER.map((k) => ({ key: k, label: TEMPLATE_KINDS[k].label })),
    ];
    return (
        <div className="flex gap-1 shrink-0">
            {tabs.map((tab) => {
                const active = value === tab.key;
                return (
                    <button
                        key={tab.key || 'ALL'}
                        type="button"
                        onClick={() => onChange(tab.key)}
                        className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs whitespace-nowrap border transition-colors ${
                            active
                                ? 'bg-slate-800 border-slate-800 text-white dark:bg-slate-100 dark:text-slate-900'
                                : 'bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 text-gray-600 dark:text-gray-300 hover:border-gray-300'
                        }`}
                    >
                        {tab.label}
                        <span className={`rounded-full px-1.5 ${active ? 'bg-white/20' : 'bg-slate-100 dark:bg-slate-700 text-gray-500'}`}>
                            {counts[tab.key || 'ALL'] ?? 0}
                        </span>
                    </button>
                );
            })}
        </div>
    );
};

export default TemplateKindTabs;
